/**
 * Conroo REST Frontend Backend
 * REST Interface for new Conroo backend for frontend app communication.
 *
 * OpenAPI spec version: v1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class DepotGetStatusRequestTO {
    'referenceNumber'?: string;
    'containerNumber'?: string;
    'isoCode'?: string;
    /**
    * Type of a Task
    */
    'type': DepotGetStatusRequestTOTypeEnum;
    'customerId': string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "referenceNumber",
            "baseName": "referenceNumber",
            "type": "string",
            "format": ""
        },
        {
            "name": "containerNumber",
            "baseName": "containerNumber",
            "type": "string",
            "format": ""
        },
        {
            "name": "isoCode",
            "baseName": "isoCode",
            "type": "string",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "DepotGetStatusRequestTOTypeEnum",
            "format": ""
        },
        {
            "name": "customerId",
            "baseName": "customerId",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return DepotGetStatusRequestTO.attributeTypeMap;
    }

    public constructor() {
    }
}


export type DepotGetStatusRequestTOTypeEnum = "pickup" | "delivery" ;

